import PropTypes from 'prop-types';

import Flight from './Flight';

export default {
  outbound: PropTypes.arrayOf(PropTypes.shape(Flight)).isRequired,
  inbound: PropTypes.arrayOf(PropTypes.shape(Flight)).isRequired,
};
